import getCarts from '../../integration/cart.api';
// import { getOfferId } from '../../integration/porting.api';
import { getTariffs, addTariffs, removeTariffs, getHandsets } from '../../integration/tariff.api';
import structureData from '../../../util/Format.util';
import { getCookie, getTokenFromCookies } from '../../hooks/useCookie';
import { setCode } from '../../hooks/useLocalStorage';
import { OFFER_TYPE_CODE } from '../shared/Constants';

const { POSTPAY } = OFFER_TYPE_CODE;
const setAdditionalAllowedOffers = (cart, localStore) => {
  const additionalAllowedOffers = cart?.additionalAllowedOffers?.find(
    sg => sg.serviceGroup === 'MOBILE'
  )?.number;
  if (
    additionalAllowedOffers > 0 &&
    localStore.getLocalStorage('STANDALONE_HANDSET') !== 'true' &&
    !localStore.getLocalStorage('INCOMPLETE_CART')
  ) {
    localStore.setLocalStorage('ADDITIONAL_OFFERS_ALLOWED', 'true');
  } else {
    localStore.setLocalStorage('ADDITIONAL_OFFERS_ALLOWED', 'false');
  }
};

// on select of porting option
// export const onPortingChangeService = async ({ graphql, portIn, simOnly = true }) => {
export const onPortingChangeService = async ({ graphql, portIn, simOnly = false, localStore }) => {
  try {
    const variables = {
      portIn,
      serviceGroupCode: 'MOBILE',
      simOnly,
      reference: getCookie('reference') || localStore.getLocalStorage('PROSPECTUUID') || '',
      offerType: POSTPAY,
    };
    const offerData = await getTariffs({ graphql, variables });
    const result = {
      offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
      discounts: offerData.discounts,
    };
    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
};

// on select of toggle button
export const getTariffWithSimo = async ({ graphql, simOnly = true, localStorage }) => {
  try {
    let variables = {
      simOnly,
      serviceGroupCode: 'MOBILE',
      portIn: localStorage.getLocalStorage('portIn') === 'true',
      reference: localStorage.getLocalStorage('PROSPECTUUID') || getCookie('reference') || '',
      offerType: POSTPAY,
    };
    if (getCookie('cart_Type') === 'CROSS_SELL') {
      variables = {
        simOnly,
        serviceGroupCode: 'MOBILE',
        portIn: localStorage.getLocalStorage('portIn') === 'true',
        reference: getCookie('reference'),
      };
    }

    if (getCookie('cart_Type') === 'CHANGE_OFFER') {
      variables = {
        simOnly,
        serviceGroupCode: 'MOBILE',
        reference: getCookie('reference'),
        offerType: POSTPAY,
      };
    }
    const offerData = await getTariffs({ graphql, variables });
    const result = {
      offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
      discounts: offerData.discounts,
    };
    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
};

// on select of offer card
// ! NOTE: This function will be refactored to handle two mobile offers in a prospect. Currently it is able to handle only one.
export const onOfferCardSelected = async ({ graphql, selectedOffer, localStorage, cart }) => {
  try {
    let variables = {
      reference: getCookie('reference') || localStorage.getLocalStorage('PROSPECTUUID') || '',
      catalogOfferCode: selectedOffer.offerCode,
      catalogTariffPlanCode: selectedOffer.code,
      portIn:
        localStorage.getLocalStorage('portIn') === 'true' ||
        localStorage.getLocalStorage('STANDALONE_PORTIN') === 'true',
      serviceGroup: 'MOBILE',
    };

    // if a mobile offer is already in cart
    if (cart?.offers.length > 0) {
      const mobileOffers = cart.offers.filter(offer => offer.baseOffer?.serviceGroup === 'MOBILE');
      const offers = [];
      mobileOffers.map(offer => offers.push({ id: offer.id }));
      if (getCookie('cart_Type') === 'CHANGE_OFFER') {
        variables = {
          ...variables,
          offerId: offers[0].id,
        };
      } else {
        variables = {
          ...variables,
          offers,
        };
      }
    }
    // If it is second mobile journey
    if (localStorage.getLocalStorage('ADDITIONAL_OFFERS_ALLOWED') === 'true') {
      variables = {
        ...variables,
        isSecondMobileJourney: true,
      };
    }
    // If prospect is not available in localstorage
    if (!localStorage.hasValue('PROSPECTUUID')) {
      variables = {
        ...variables,
        reference: getCookie('reference') || '',
        offerType: POSTPAY,
      };
    }

    const result = await addTariffs({ graphql, variables });
    if (!localStorage.hasValue('PROSPECTUUID'))
      if (result?.addTariff?.reference)
        localStorage.setLocalStorage('PROSPECTUUID', result.addTariff.reference);
    return result.addTariff;
  } catch (err) {
    console.error(err);
    return { error: err };
  }
};

// on unselect of offer card
export const onOfferCardUnSelected = async ({ graphql, localStorage, cart }) => {
  try {
    // if a mobile offer is already in cart
    const offerLength = cart.offers.filter(
      offer => offer.baseOffer?.serviceGroup === 'MOBILE'
    ).length;
    if (offerLength > 0) {
      const offerId = cart.offers.filter(offer => offer.baseOffer?.serviceGroup === 'MOBILE')[
        offerLength - 1
      ]?.id;
      const result = await removeTariffs({
        graphql,
        variables: {
          reference: localStorage.getLocalStorage('prospectUuid') || getCookie('reference') || '',
          offerId,
          serviceGroup: getCookie('cart_Type') === 'CHANGE_OFFER' ? 'MOBILE' : '',
        },
      });
      setAdditionalAllowedOffers(result.removeTariff, localStorage);
      return result.removeTariff;
    }
  } catch (err) {
    console.error(err);
    return null;
  }
};

// ! NOTE: This function will be refactored to handle two mobile offers in a prospect. Currently it is able to handle only one.
export const onGetHandsets = async ({ graphql, localStorage, cart }) => {
  try {
    let variable = {};

    if (cart?.offers.length > 0) {
      const offerId = cart.offers
        .filter(offer => offer.baseOffer?.serviceGroup === 'MOBILE')
        .sort((a, b) => b.id - a.id)[0]?.id;

      variable = {
        reference: localStorage.getLocalStorage('prospectUuid') || getCookie('reference') || '',
        offerType: POSTPAY,
        cartOfferID: offerId,
        portIn: localStorage.getLocalStorage('portIn') === 'true',
        cartType: getCookie('cart_Type'),
        token: getTokenFromCookies(),
      };

      if (!getCookie('cart_Type')) delete variable.cartType;
      const result = await getHandsets({ graphql, variables: variable });
      return { result };
    }
  } catch (err) {
    console.error(err);
    return { error: err };
  }
};

const getSelectedMobileOfferFromCart = async ({ graphql, localStorage }) => {
  // get the selected offer value from prospect.
  let variables = {};
  if (getCookie('cart_Type') === 'CROSS_SELL') {
    setCode('CS');
    variables = {
      reference: getCookie('reference'),
      cartType: 'CROSS_SELL',
      token: getTokenFromCookies(),
    };
  } else if (getCookie('cart_Type') === 'CHANGE_OFFER') {
    setCode('CO');
    variables = {
      reference: getCookie('reference'),
      cartType: 'CHANGE_OFFER',
      token: getTokenFromCookies(),
    };
  } else {
    variables = {
      reference: localStorage.getLocalStorage('PROSPECTUUID') || getCookie('reference') || '',
    };
  }
  try {
    const { getCart: cartData } = await getCarts({
      graphql,
      variables,
    });
    if (cartData === null) {
      return {
        cartData: {},
        selectedOffer: [],
      };
    }
    return {
      cartData,
      selectedOffer: cartData.offers.filter(offer => offer?.baseOffer?.serviceGroup === 'MOBILE'),
    };
  } catch (err) {
    // if (err.message.includes(getCookie('reference'))) {
    //   return {
    //     cartData: {},
    //     selectedOffer: [],
    //   };
    // }
    throw new Error(err.message);
  }
};

export const onload = async ({ graphql, localStorage, dispatch, SecondBillPayPlanNeeded }) => {
  let variables = { simOnly: false, serviceGroupCode: 'MOBILE', offerType: POSTPAY };
  let result = {};
  let selectedMobileOffer = {};
  let handsetList = null;
  let brandList = null;
  dispatch({ type: 'ENABLE_FOOTER', payload: false });
  dispatch({ type: 'SET_CHECKOUT_BUTTON', payload: false });
  try {
    // if prospect is present
    if (
      localStorage.hasValue('PROSPECTUUID') ||
      getCookie('MYEIR_TV_ADDED') ||
      getCookie('reference')
    ) {
      // getting selected mobile offers from cart
      const { selectedOffer, cartData } = await getSelectedMobileOfferFromCart({
        graphql,
        localStorage,
      });
      if (Object.keys(cartData).length !== 0) {
        setAdditionalAllowedOffers(cartData, localStorage);
        dispatch({ type: 'SET_CART', payload: cartData });
      }
      variables = {
        ...variables,
        portIn: localStorage.getLocalStorage('portIn') === 'true',
        simOnly: localStorage.getLocalStorage('GET_SIMONLY')
          ? true
          : selectedOffer.sort((a, b) => b - a)[0]?.baseOffer?.simOnly,
        reference: localStorage.getLocalStorage('PROSPECTUUID') || getCookie('reference'),
      };
      const sortedOffersInCart = selectedOffer.sort((a, b) => b.id - a.id);
      // This if will be called when last plan selected is simonly
      if (
        selectedOffer.sort((a, b) => b - a)[0]?.baseOffer?.simOnly === true &&
        !SecondBillPayPlanNeeded
      ) {
        variables = {
          ...variables,
          simOnly: true,
        };
        const offerData = await getTariffs({ graphql, variables });
        selectedMobileOffer =
          localStorage.getLocalStorage('INCOMPLETE_PORTING') === 'true' ||
          getCookie('cart_Type') === 'CHANGE_OFFER'
            ? {
                offer: structureData(
                  offerData?.tariffs.filter(
                    offer =>
                      selectedOffer.sort((a, b) => b - a)[0]?.baseOffer?.catalogTariffPlanCode ===
                      offer.code
                  )[0]
                ),
                simOnly: true,
              }
            : {
                offer: null,
                simOnly: true,
              };
        result = {
          offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
          discounts: offerData?.discounts,
          cartData,
          selectedMobileOffer,
        };
      }
      // This else if will be called when last plan selected is billpay
      else if (
        selectedOffer.sort((a, b) => b - a)[0]?.baseOffer?.simOnly === false &&
        selectedOffer.sort((a, b) => b - a)[0]?.equipments.length === 0
      ) {
        variables = {
          ...variables,
          simOnly: false,
        };
        // If Cart is incomplete i.e moved to summary page without selecting handset
        const offerData = await getTariffs({ graphql, variables });
        const { result: devices } = await onGetHandsets({
          graphql,
          localStorage,
          cart: cartData,
        });
        handsetList = devices.getHandsets.handsets;
        brandList = devices.getHandsets.manufacturers;
        selectedMobileOffer = {
          offer: structureData(
            offerData?.tariffs.filter(
              offer =>
                sortedOffersInCart.sort((a, b) => b - a)[0]?.baseOffer?.catalogTariffPlanCode ===
                offer.code
            )[0]
          ),
          simOnly: false,
        };
        result = {
          offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
          discounts: offerData?.discounts,
          cartData,
          selectedMobileOffer,
          handsetList,
          brandList,
        };
      }
      // This else will be called on by default onload call
      else {
        variables = {
          ...variables,
          simOnly: !SecondBillPayPlanNeeded,
        };

        const offerData = await getTariffs({ graphql, variables });
        selectedMobileOffer = {
          offer: null,
          simOnly: true,
        };
        result = {
          offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
          discounts: offerData?.discounts,
          cartData,
          selectedMobileOffer,
        };
      }
    }
  } catch (error) {
    console.error('something went wrong on load of /shop/mobile', error);
  }
  return result;
};

// on change offer mobile journey
export const getCoTarrif = async ({ graphql, simOnly = true, localStorage, dispatch }) => {
  try {
    let selectedMobileOffer = {
      offer: null,
      simOnly: true,
    };
    let handsetList;
    let brandList;
    const variables = {
      serviceGroupCode: 'MOBILE',
      offerType: POSTPAY,
      simOnly,
      reference: getCookie('reference') || localStorage.getLocalStorage('REF'),
    };
    const offerData = await getTariffs({ graphql, variables });
    const { selectedOffer, cartData } = await getSelectedMobileOfferFromCart({
      graphql,
      localStorage,
    });
    if (selectedOffer.length > 0) {
      if (!simOnly) {
        const { result: devices } = await onGetHandsets({
          graphql,
          localStorage,
          cart: cartData,
        });
        handsetList = devices.getHandsets.handsets;
        brandList = devices.getHandsets.manufacturers;
      }
      const sortedOffersInCart = selectedOffer.sort((a, b) => b.id - a.id);
      selectedMobileOffer = {
        offer: structureData(
          offerData?.tariffs.filter(
            offer =>
              sortedOffersInCart.sort((a, b) => b - a)[0]?.baseOffer?.catalogTariffPlanCode ===
              offer.code
          )[0]
        ),
        simOnly: false,
      };
      if (Object.keys(cartData).length !== 0) {
        dispatch({ type: 'SET_CART', payload: cartData });
      }
    }
    const result = {
      offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
      discounts: offerData.discounts,
      cartData,
      selectedMobileOffer,
      handsetList,
      brandList,
    };
    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
};
// export const getCoTarrif = async ({ graphql, simOnly = true, localStorage }) => {
//   try {
//     const variables = {
//       serviceGroupCode: 'MOBILE',
//       simOnly,
//       reference: getCookie('reference') || localStorage.getLocalStorage('REF'),
//     };
//     const offerData = await getTariffs({ graphql, variables });
//     const result = {
//       offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
//       discounts: offerData.discounts,
//     };
//     return result;
//   } catch (err) {
//     console.error(err);
//     return null;
//   }
// };

export const mobileHandsetDetailsOnLoad = async ({
  graphql,
  localStorage,
  dispatch,
  mobileHandsetCode,
}) => {
  let variables = { simOnly: false, serviceGroupCode: 'MOBILE' };
  let result = {};
  let selectedMobileOffer = {};
  dispatch({ type: 'ENABLE_FOOTER', payload: false });
  dispatch({ type: 'SET_CHECKOUT_BUTTON', payload: false });
  try {
    const { selectedOffer, cartData } = await getSelectedMobileOfferFromCart({
      graphql,
      localStorage,
    });
    setAdditionalAllowedOffers(cartData, localStorage);
    dispatch({ type: 'SET_CART', payload: cartData });
    variables = {
      ...variables,
      portIn: localStorage.getLocalStorage('STANDALONE_PORTIN') === 'true',
      reference: getCookie('reference') || localStorage.getLocalStorage('PROSPECTUUID'),
      equipmentCode: mobileHandsetCode,
    };
    const sortedOffersInCart = selectedOffer.sort((a, b) => b.id - a.id);
    if (getCookie('cart_Type') === 'CHANGE_OFFER') delete variables.portIn;
    // It is a second mobile journey
    if (selectedOffer.length > 1) {
      const offerData = await getTariffs({ graphql, variables });
      if (
        getCookie('cart_Type') === 'CHANGE_OFFER' &&
        offerData?.tariffs?.filter(
          offer =>
            selectedOffer.sort((a, b) => b - a)[0]?.baseOffer?.catalogCode === offer.offerCode
        ).length === 0
      ) {
        selectedMobileOffer = {
          offer: null,
          simOnly: false,
        };
      } else {
        selectedMobileOffer = {
          offer:
            mobileHandsetCode && !localStorage.getLocalStorage('HANDSET_BE_OFFERID')
              ? structureData(
                  offerData?.tariffs?.filter(
                    offer =>
                      sortedOffersInCart.sort((a, b) => b - a)[0]?.baseOffer?.catalogCode ===
                      offer.offerCode
                  )[0]
                )
              : null,
          simOnly: false,
        };
      }
      result = {
        offers: offerData?.tariffs.map(offer => structureData(offer, graphql)),
        discounts: offerData?.discounts,
        cartData,
        selectedMobileOffer,
      };
    }
    // It is a first mobile journey
    else if (selectedOffer.length === 1) {
      const offerData = await getTariffs({ graphql, variables });
      if (getCookie('cart_Type') === 'CHANGE_OFFER') {
        if (
          offerData?.tariffs?.filter(
            offer =>
              selectedOffer.sort((a, b) => b - a)[0]?.baseOffer?.catalogCode === offer.offerCode
          ).length === 0
        ) {
          selectedMobileOffer = {
            offer: null,
            simOnly: false,
          };
        } else {
          selectedMobileOffer = {
            offer: mobileHandsetCode
              ? structureData(
                  offerData?.tariffs?.filter(
                    offer =>
                      sortedOffersInCart.sort((a, b) => b - a)[0]?.baseOffer?.catalogCode ===
                      offer.offerCode
                  )[0]
                )
              : null,
            simOnly: false,
          };
        }
      } else {
        selectedMobileOffer = {
          offer:
            mobileHandsetCode && !localStorage.getLocalStorage('HANDSET_BE_OFFERID')
              ? structureData(
                  offerData?.tariffs?.filter(
                    offer =>
                      sortedOffersInCart.sort((a, b) => b - a)[0]?.baseOffer?.catalogCode ===
                      offer.offerCode
                  )[0]
                )
              : null,
          simOnly: false,
        };
      }
      result = {
        offers: offerData?.tariffs?.map(offer => structureData(offer, graphql)),
        discounts: offerData?.discounts,
        cartData,
        selectedMobileOffer,
      };
    }
  } catch (error) {
    console.error('something went wrong on load of /shop/mobile', error);
  }
  return result;
};
